export const sanitizeLink = (link) => {
    if (!link) return '';
    const url = new URL(link, window.location.origin);
    return url.pathname + url.search + url.hash;
};

export const sanitizeQuery = (rawQueryStr) => {
    const urlParams = new URLSearchParams(rawQueryStr);
    const sanitizedParams = new URLSearchParams();
    urlParams.forEach((value, key) => {
        sanitizedParams.set(key, encodeURIComponent(value));
    });

    return sanitizedParams.toString();
};
